import { useCompanyStore } from '@/store/company'

const getCurrentCompanyId = () => {
  return useCompanyStore().getCurrentCompanyId
}

export default getCurrentCompanyId
